<template>
  <v-container :class="bg_color + ' lighten-5 pa-0 page-cmp-lmnt'" fill-height fluid>
    <v-row class="fill-height pa-0 page-row-cmp-lmnt" align="stretch">
      <v-col cols="12" class="page-col-container pa-0">
        <v-row
          :justify="'space-between'"
          :class="bg_color + '  lighten-5 fill-height'"
          no-gutters
          align="stretch"
        >
          <slot></slot>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Page",
  props: {
    bg_color: {
      type: String,
       default: "grey"
    }
  }
};
</script>